import moment from 'moment'

//export default function getUnixTimeFromMoment(momentObj) {
//  return moment(momentObj).unix()
//}

const getUnixDateFromMoment = (momentObj) =>
  moment(momentObj).unix()

export default getUnixDateFromMoment


// WEBPACK FOOTER //
// ./src/utils/get-unix-date-from-moment.js